var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticStyle:{"margin-top":"10vh"}},[_c('el-empty',{attrs:{"image":_vm.src,"description":'暂无' + _vm.text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }